import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { useSelector } from "react-redux";
import defaultBanner from "../../Assets/defaultBanner.png";
import { Dispatch, trackEvent } from "../Utility/Utility";
import { onUpdateOrderReset } from "../../Store/Slices/orderSlice";
import MobileSlider from "./MobileSlider";

const Slider = () => {
  const [groupedCarouselData, setGroupedCarouselData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [currentIndex, setCurrentIndex] = useState(0);
  const dispatch = Dispatch();

  const getCarouselData = useSelector(
    (state) => state.offerMasterReducer?.getofferMaster
  );

  // handle resize responsiveness
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Build carousel data
  useEffect(() => {
    const buildCarouselData = () => {
      if (!Array.isArray(getCarouselData)) return;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const enabledData = getCarouselData.filter((item) => {
        if (!item.enabled || item.placement !== "Main") return false;
        const startDate = new Date(item.startDate);
        const endDate = new Date(item.endDate);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        return today >= startDate && today <= endDate;
      });

      const sortedData = [...enabledData].sort(
        (a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder)
      );

      const groupedData = [];
      const length = sortedData.length;
      if (window.innerWidth < 992) {
        sortedData.forEach((item) => groupedData.push([item]));
      } else {
        for (let i = 0; i < length; i++) {
          const currentItem = sortedData[i];
          const nextItem = sortedData[(i + 1) % length];
          groupedData.push([currentItem, nextItem]);
        }
      }
      setGroupedCarouselData(groupedData);
    };

    buildCarouselData();
    window.addEventListener("resize", buildCarouselData);
    return () => window.removeEventListener("resize", buildCarouselData);
  }, [getCarouselData]);

  useEffect(() => {
    dispatch(onUpdateOrderReset());
  }, [dispatch]);

  // dot click handler
  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };
  return (
    <>
      {groupedCarouselData.length > 0 && (
        <>
          {isMobile ? (
            <>
              <MobileSlider
                groupedCarouselData={groupedCarouselData}
                autoSlideInterval={6000}
                defaultBanner={defaultBanner}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
              />
            </>
          ) : (
            <div className="mainDiv">
              <Carousel
                controls={false}
                interval={6000}
                wrap={true}
                activeIndex={currentIndex}
                onSelect={(selectedIndex) => setCurrentIndex(selectedIndex)}
              >
                {groupedCarouselData.map((group, index) => (
                  <Carousel.Item key={index}>
                    <section className="section-hero pt-4">
                      <div className="container">
                        <div className="row hero justify-content-center">
                          {group.map((offerMasterData, idx) => (
                            <div className="col-lg-6" key={idx}>
                              <div className="side-ban-img">
                                <img
                                  className="banner_image_width"
                                  src={`${process.env.REACT_APP_CLIENT_URL}${offerMasterData?.mobileImage}`}
                                  alt="Banner"
                                  style={{ width: "100%" }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = defaultBanner;
                                  }}
                                  onClick={() => {
                                    const fullUrl = `${offerMasterData?.mobileImage}`;
                                    trackEvent("banner_click", {
                                      title: fullUrl.substring(
                                        fullUrl.lastIndexOf("/") + 1,
                                        fullUrl.lastIndexOf(".")
                                      ),
                                      page_url: fullUrl,
                                      item_image: `${process.env.REACT_APP_CLIENT_URL}${offerMasterData?.mobileImage}`,
                                      section_title: offerMasterData?.placement,
                                    });
                                    window.location.href =
                                      offerMasterData?.link;
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </section>
                  </Carousel.Item>
                ))}
              </Carousel>
              {groupedCarouselData.length > 2 && (
                <div className="dots-container text-center mt-3">
                  {groupedCarouselData.map((_, index) => (
                    <span
                      key={index}
                      className={`dot1 ${index === currentIndex ? "active" : ""
                        }`}
                      onClick={() => handleDotClick(index)}
                    ></span>
                  ))}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Slider;
